import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f509cd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header border-0 pt-5" }
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = { class: "d-flex flex-wrap align-items-center justify-content-between gap-3" }
const _hoisted_11 = { class: "d-flex flex-wrap align-items-center gap-3" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "d-flex align-items-center gap-3" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "table align-middle fs-6 gy-5" }
const _hoisted_16 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-country-tip" }, "多个国家代码用逗号分隔", -1))
const _hoisted_22 = {
  key: 0,
  class: "d-flex justify-content-end mb-3"
}
const _hoisted_23 = { class: "check-controls" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "自动刷新间隔", -1))
const _hoisted_25 = { class: "check-action-wrap" }
const _hoisted_26 = {
  key: 2,
  class: "check-countdown"
}
const _hoisted_27 = { class: "check-result-wrap" }
const _hoisted_28 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_29 = { class: "check-result-line1" }
const _hoisted_30 = {
  key: 0,
  class: "check-result-spinner"
}
const _hoisted_31 = { class: "check-result-strong" }
const _hoisted_32 = { class: "check-result-strong" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-result-label" }, "avg:", -1))
const _hoisted_34 = { class: "check-result-badge" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-result-label" }, "loss:", -1))
const _hoisted_36 = { class: "check-result-badge" }
const _hoisted_37 = { class: "check-result-line2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "check-result-label" }, "resolved address:", -1))
const _hoisted_39 = { class: "check-result-badge" }
const _hoisted_40 = { class: "dialog-footer" }

import {
  computed,
  getCurrentInstance,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import { ElMessageBox } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import ServerServices from "../services/ServerServices";

type SortField = "id" | "created_at" | "updated_at" | "expires";
type SortDirection = "asc" | "desc";
type SortByValue =
  | "id_asc"
  | "created_at_asc"
  | "created_at_desc"
  | "updated_at_desc"
  | "expires_asc"
  | "expires_desc";
type DomainRecord = Record<string, any>;
type DomainTabValue =
  | "all"
  | "expired"
  | "expiring_soon"
  | "not_expired"
  | "unregistered";

const oneMonthMs = 30 * 24 * 60 * 60 * 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerDomains',
  setup(__props) {

const isLoading = ref(false);
const isSubmitting = ref(false);
const sortBy = ref<SortByValue>("expires_asc");
const searchKeyword = ref("");
const items = ref<DomainRecord[]>([]);
const domainTabStatus = {
  All: "all",
  Expired: "expired",
  ExpiringSoon: "expiring_soon",
  NotExpired: "not_expired",
  Unregistered: "unregistered",
} as const;
const activeDomainTab = ref<DomainTabValue>(domainTabStatus.All);
const { t, te } = useI18n();
const instance = getCurrentInstance();
const proxy = instance?.proxy as any;

const detailVisible = ref(false);
const currentDomainId = ref<number | null>(null);
const dialogForm = ref<DomainRecord>({});
const dialogMode = ref<"create" | "edit">("edit");
const createFormRef = ref<any>();
const isCheckLoading = ref(false);
const isDnsChecking = ref(false);
const dnsCheckingDomainId = ref<number | null>(null);
const isRefreshingRequest = ref(false);
const isAutoRefreshing = ref(false);
const deletingDomainId = ref<number | null>(null);
const checkResultEntries = ref<any[]>([]);
const refreshIntervalSec = ref(5);
const refreshIntervalInput = ref(5);
const refreshCountdownSec = ref(5);
let refreshTimer: ReturnType<typeof setInterval> | null = null;

const createFields = ["domain", "registrar", "username", "category"];
const detailEditableFields = ["domain", "category", "registrar", "username"];

const toRows = (fields: string[], rowSize = 2) => {
  const rows: string[][] = [];
  for (let i = 0; i < fields.length; i += rowSize) {
    rows.push(fields.slice(i, i + rowSize));
  }
  return rows;
};

const detailEditableFieldRows = computed(() => toRows(detailEditableFields));
const isSuperAdmin = computed(() => Boolean(proxy?.$can?.("SuperAdmin")));

const detailFormFields = [
  ...detailEditableFields,
  "dns",
  "expires",
  "id",
  "check_country",
  "check_id",
  "check_result",
];

const isCreateMode = computed(() => dialogMode.value === "create");
const dialogTitle = computed(() =>
  isCreateMode.value
    ? t("action.addDomain")
    : `${t("title.domainDetail")} - ${formatCell(
        dialogForm.value.domain
      )} (${formatCell(dialogForm.value.id)})`
);
const isCheckIdEmpty = computed(() => {
  const value = dialogForm.value.check_id;
  return value === null;
});
const createFormRules = computed(() => ({
  domain: [
    {
      required: true,
      message: t("error.fieldIsRequired"),
      trigger: ["blur", "change"],
    },
  ],
  registrar: [
    {
      required: true,
      message: t("error.fieldIsRequired"),
      trigger: ["blur", "change"],
    },
  ],
  username: [
    {
      required: true,
      message: t("error.fieldIsRequired"),
      trigger: ["blur", "change"],
    },
  ],
}));

const getSortLabel = (
  fieldKey: "id" | "created_at" | "updated_at" | "expires",
  orderKey: "default" | "earliest" | "latest"
) => {
  const orderText =
    orderKey === "default" ? t("status.default") : t(`fields.${orderKey}`);

  return `${t(`fields.${fieldKey}`)} (${orderText})`;
};

const getFieldLabel = (field: string) => {
  const key = `fields.${field}`;
  return te(key) ? t(key) : field;
};

const normalizeResponse = (response: any): DomainRecord[] => {
  if (Array.isArray(response)) {
    return response;
  }
  if (Array.isArray(response?.data)) {
    return response.data;
  }
  return [];
};

const parseSortBy = (value: SortByValue): [SortField, SortDirection] => {
  const direction: SortDirection = value.endsWith("_desc") ? "desc" : "asc";
  const field = value.replace(/_(asc|desc)$/, "") as SortField;
  return [field, direction];
};

const parseDateTimestamp = (value: any): number => {
  if (!value) {
    return Number.MAX_SAFE_INTEGER;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : Number.MAX_SAFE_INTEGER;
  }

  const raw = String(value).trim();
  if (!raw) {
    return Number.MAX_SAFE_INTEGER;
  }

  // Normalize fractional seconds to milliseconds for broader browser parsing compatibility.
  const normalized = raw.replace(/\.(\d{3})\d+Z$/, ".$1Z");
  const timestamp = new Date(normalized).getTime();

  return Number.isFinite(timestamp) ? timestamp : Number.MAX_SAFE_INTEGER;
};

const parseDateTimestampNullable = (value: any): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const raw = String(value).trim();
  if (!raw) {
    return null;
  }

  const normalized = raw.replace(/\.(\d{3})\d+Z$/, ".$1Z");
  const timestamp = new Date(normalized).getTime();

  return Number.isFinite(timestamp) ? timestamp : null;
};

const sortValue = (item: DomainRecord, field: SortField): number => {
  const value = item?.[field];

  if (field === "id") {
    const num = Number(value);
    return Number.isFinite(num) ? num : Number.MAX_SAFE_INTEGER;
  }

  if (!value) {
    return Number.MAX_SAFE_INTEGER;
  }

  return parseDateTimestamp(value);
};

const isUnregisteredDomain = (item: DomainRecord) => {
  return String(item?.status ?? "").toLowerCase() === "unregistered";
};

const matchDomainTab = (item: DomainRecord) => {
  if (activeDomainTab.value === domainTabStatus.All) {
    return true;
  }

  const isUnregistered = isUnregisteredDomain(item);

  if (activeDomainTab.value === domainTabStatus.Unregistered) {
    return isUnregistered;
  }

  if (isUnregistered) {
    return false;
  }

  const expiresTs = parseDateTimestampNullable(item?.expires);
  if (expiresTs === null) {
    return false;
  }

  const now = Date.now();

  if (activeDomainTab.value === domainTabStatus.Expired) {
    return expiresTs < now;
  }

  if (activeDomainTab.value === domainTabStatus.ExpiringSoon) {
    return expiresTs >= now && expiresTs <= now + oneMonthMs;
  }

  if (activeDomainTab.value === domainTabStatus.NotExpired) {
    return expiresTs > now;
  }

  return true;
};

const filteredAndSortedItems = computed(() => {
  const cloned = [...items.value];
  const keyword = searchKeyword.value.trim().toLowerCase();

  const tabFiltered = cloned.filter((item) => matchDomainTab(item));

  const filtered = keyword
    ? tabFiltered.filter((item) => {
        const domain = String(item?.domain ?? "").toLowerCase();
        const username = String(item?.username ?? "").toLowerCase();
        return domain.includes(keyword) || username.includes(keyword);
      })
    : tabFiltered;

  const [field, direction] = parseSortBy(sortBy.value);

  return filtered.sort((a, b) => {
    const result = sortValue(a, field) - sortValue(b, field);
    return direction === "desc" ? -result : result;
  });
});

const formatCell = (value: any) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  return String(value);
};

const expiresTextClass = (value: any) => {
  const timestamp = parseDateTimestampNullable(value);
  if (timestamp === null) {
    return "text-muted";
  }

  return timestamp < Date.now() ? "text-danger" : "text-success";
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const response = await ServerServices.getDomains();
    items.value = normalizeResponse(response);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const onSortChange = () => {
  // Sorting is computed locally from sortBy.
};

const toDisplayValue = (value: any) => {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value);
};

const makeForm = (fields: string[], source: DomainRecord = {}) => {
  const form: DomainRecord = {};
  fields.forEach((field) => {
    if (field === "check_id") {
      form[field] = source?.[field] ?? null;
      return;
    }
    form[field] = toDisplayValue(source?.[field]);
  });
  return form;
};

const syncDetailFormFromSource = (source: DomainRecord = {}) => {
  const syncFields = [
    ...detailEditableFields,
    "dns",
    "expires",
    "id",
    "check_country",
  ];

  dialogForm.value = {
    ...dialogForm.value,
    ...makeForm(syncFields, source),
  };
};

const openDetail = (item: DomainRecord) => {
  stopAutoRefresh();
  checkResultEntries.value = [];
  refreshCountdownSec.value = refreshIntervalSec.value;
  dialogMode.value = "edit";
  const parsedId = Number(item?.id);
  currentDomainId.value = Number.isFinite(parsedId) ? parsedId : null;
  dialogForm.value = makeForm(detailFormFields, item);
  detailVisible.value = true;
};

const createEmptyForm = () => {
  return makeForm(createFields);
};

const openCreate = () => {
  if (!isSuperAdmin.value) {
    MsgPrompt.warning("No permission");
    return;
  }

  stopAutoRefresh();
  checkResultEntries.value = [];
  refreshCountdownSec.value = refreshIntervalSec.value;
  dialogMode.value = "create";
  currentDomainId.value = null;
  dialogForm.value = createEmptyForm();
  detailVisible.value = true;
  nextTick(() => {
    createFormRef.value?.clearValidate?.();
  });
};

const normalizeSubmitValue = (field: string, value: any) => {
  if (value === "") {
    return null;
  }

  if (field === "id" || field === "status" || field === "check_id") {
    const num = Number(value);
    return Number.isFinite(num) ? num : value;
  }

  return value;
};

const buildSubmitPayload = () => {
  const payload: DomainRecord = {};

  createFields.forEach((field) => {
    payload[field] = normalizeSubmitValue(field, dialogForm.value[field]);
  });

  return payload;
};

const buildDetailUpdatePayload = () => {
  const payload: DomainRecord = {};

  [...detailEditableFields, "check_country"].forEach((field) => {
    payload[field] = normalizeSubmitValue(field, dialogForm.value[field]);
  });

  return payload;
};

const submitDetailUpdate = async () => {
  if (!isSuperAdmin.value) {
    MsgPrompt.warning("No permission");
    return;
  }

  if (currentDomainId.value === null || Number.isNaN(currentDomainId.value)) {
    MsgPrompt.warning("Invalid domain id");
    return;
  }

  isSubmitting.value = true;
  try {
    await ServerServices.updateDomainById(
      currentDomainId.value,
      buildDetailUpdatePayload()
    );
    MsgPrompt.success();
    await fetchData();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const stopAutoRefresh = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
  isAutoRefreshing.value = false;
  refreshCountdownSec.value = refreshIntervalSec.value;
};

const isRefreshFinished = (response: any) => {
  if (response?.status === "finished") {
    return true;
  }

  const results = Array.isArray(response?.results) ? response.results : [];
  if (!results.length) {
    return false;
  }

  return results.every((item: any) => item?.result?.status === "finished");
};

const formatCheckResult = (response: any) => {
  const results = Array.isArray(response?.results) ? response.results : [];
  if (!results.length) {
    return [];
  }

  return results.map((item: any) => {
    const city = item?.probe?.city ?? "-";
    const network = item?.probe?.network ?? "-";
    const avg = item?.result?.stats?.avg;
    const loss = item?.result?.stats?.loss;
    const resolvedAddress = item?.result?.resolvedAddress ?? "-";
    const status =
      item?.result?.status ?? item?.status ?? response?.status ?? "in-progress";
    const avgText = avg === null || avg === undefined ? "-" : `${avg} ms`;
    const lossText = loss === null || loss === undefined ? "-" : `${loss}%`;

    return { city, network, avgText, lossText, resolvedAddress, status };
  });
};

const applyRefreshResult = (response: any) => {
  const finished = isRefreshFinished(response);

  if (finished) {
    dialogForm.value.check_id = null;
  } else if (response?.id) {
    dialogForm.value.check_id = response.id;
  } else {
    dialogForm.value.check_id = null;
  }
  checkResultEntries.value = formatCheckResult(response);
  dialogForm.value.check_result = checkResultEntries.value.length
    ? "HAS_RESULT"
    : "";

  if (finished) {
    stopAutoRefresh();
  }
};

const refreshCheckResult = async (showError = true) => {
  if (isRefreshingRequest.value) {
    return;
  }

  if (currentDomainId.value === null || Number.isNaN(currentDomainId.value)) {
    if (showError) {
      MsgPrompt.warning("Invalid domain id");
    }
    return;
  }

  isRefreshingRequest.value = true;
  isCheckLoading.value = true;

  try {
    const response = await ServerServices.refreshDomainById(
      currentDomainId.value
    );
    applyRefreshResult(response);
    return response;
  } catch (error) {
    if (showError) {
      MsgPrompt.error(error);
    }
  } finally {
    isRefreshingRequest.value = false;
    isCheckLoading.value = false;
  }
};

const startAutoRefresh = () => {
  stopAutoRefresh();
  isAutoRefreshing.value = true;
  refreshCountdownSec.value = refreshIntervalSec.value;

  refreshTimer = setInterval(() => {
    if (refreshCountdownSec.value <= 1) {
      refreshCountdownSec.value = refreshIntervalSec.value;
      void refreshCheckResult(false);
      return;
    }

    refreshCountdownSec.value -= 1;
  }, 1000);
};

const handleSaveRefreshInterval = () => {
  const value = Number(refreshIntervalInput.value);
  if (!Number.isFinite(value) || value <= 0) {
    MsgPrompt.warning("自动刷新间隔必须大于0");
    return;
  }

  refreshIntervalSec.value = Math.floor(value);
  refreshIntervalInput.value = refreshIntervalSec.value;
  refreshCountdownSec.value = refreshIntervalSec.value;

  if (refreshTimer) {
    startAutoRefresh();
  }

  MsgPrompt.success();
};

const handleCheck = async () => {
  if (currentDomainId.value === null || Number.isNaN(currentDomainId.value)) {
    MsgPrompt.warning("Invalid domain id");
    return;
  }

  isCheckLoading.value = true;
  try {
    const response = await ServerServices.checkDomainById(
      currentDomainId.value
    );
    if (response?.id) {
      dialogForm.value.check_id = toDisplayValue(response.id);
    }

    const refreshResponse = await refreshCheckResult();
    if (refreshResponse && !isRefreshFinished(refreshResponse)) {
      startAutoRefresh();
    }
    MsgPrompt.success();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isCheckLoading.value = false;
  }
};

const handleDnsCheck = async (item?: DomainRecord) => {
  const parsedId = Number(item?.id ?? currentDomainId.value);
  if (!Number.isFinite(parsedId)) {
    MsgPrompt.warning("Invalid domain id");
    return;
  }

  // DNS check should only call dns endpoint and update list/detail with latest data.
  stopAutoRefresh();
  isDnsChecking.value = true;
  dnsCheckingDomainId.value = parsedId;
  try {
    const response = await ServerServices.checkDomainDnsById(parsedId);
    const checkStatus = Number(response?.check_status);

    if (checkStatus !== 200) {
      MsgPrompt.warning(response?.message || "DNS check failed");
      return;
    }

    await fetchData();

    if (detailVisible.value && currentDomainId.value === parsedId) {
      const latestItem = items.value.find(
        (row) => Number(row?.id) === parsedId
      );

      if (latestItem) {
        syncDetailFormFromSource(latestItem);
      } else if (response && typeof response === "object") {
        syncDetailFormFromSource({
          ...response,
          dns: response?.whois_server ?? response?.dns,
          expires: response?.expiration_date ?? response?.expires,
        });
      }
    }

    MsgPrompt.success();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isDnsChecking.value = false;
    dnsCheckingDomainId.value = null;
  }
};

const handleRefresh = async () => {
  const response = await refreshCheckResult();
  if (response) {
    MsgPrompt.success();
    if (!isRefreshFinished(response)) {
      startAutoRefresh();
    }
  }
};

const handleDelete = async (item: DomainRecord) => {
  if (!isSuperAdmin.value) {
    MsgPrompt.warning("No permission");
    return;
  }

  const parsedId = Number(item?.id);
  if (!Number.isFinite(parsedId)) {
    MsgPrompt.warning("Invalid domain id");
    return;
  }

  try {
    await ElMessageBox.confirm(
      `${t("tip.areYouSureToDelete")} ${formatCell(item?.domain)}`,
      t("action.delete"),
      {
        type: "warning",
        confirmButtonText: t("action.confirm"),
        cancelButtonText: t("action.cancel"),
      }
    );
  } catch {
    return;
  }

  deletingDomainId.value = parsedId;

  try {
    await ServerServices.deleteDomainById(parsedId);
    MsgPrompt.success();
    await fetchData();
    if (currentDomainId.value === parsedId) {
      detailVisible.value = false;
    }
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    deletingDomainId.value = null;
  }
};

const isDeleting = (id: any) => deletingDomainId.value === Number(id);

const submitCreate = async () => {
  if (!isSuperAdmin.value) {
    MsgPrompt.warning("No permission");
    return;
  }

  const isValid = await createFormRef.value
    ?.validate?.()
    .then(() => true)
    .catch(() => false);

  if (!isValid) {
    return;
  }

  isSubmitting.value = true;
  try {
    const payload = buildSubmitPayload();

    await ServerServices.createDomain(payload);
    MsgPrompt.success();
    detailVisible.value = false;
    await fetchData();
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

watch(
  () => detailVisible.value,
  (visible) => {
    if (!visible) {
      stopAutoRefresh();
    }
  }
);

onBeforeUnmount(() => {
  stopAutoRefresh();
});

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-3", [
            { active: activeDomainTab.value === domainTabStatus.All },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (activeDomainTab.value = domainTabStatus.All), ["prevent"]))
        }, _toDisplayString(_ctx.$t("status.all")), 3)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-3", [
            { active: activeDomainTab.value === domainTabStatus.Expired },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (activeDomainTab.value = domainTabStatus.Expired), ["prevent"]))
        }, _toDisplayString(_ctx.$t("status.expired")), 3)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-3", [
            { active: activeDomainTab.value === domainTabStatus.ExpiringSoon },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (activeDomainTab.value = domainTabStatus.ExpiringSoon), ["prevent"]))
        }, _toDisplayString(_ctx.$t("status.expiringSoon")), 3)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-3", [
            { active: activeDomainTab.value === domainTabStatus.NotExpired },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (activeDomainTab.value = domainTabStatus.NotExpired), ["prevent"]))
        }, _toDisplayString(_ctx.$t("status.notExpired")), 3)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-3", [
            { active: activeDomainTab.value === domainTabStatus.Unregistered },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (activeDomainTab.value = domainTabStatus.Unregistered), ["prevent"]))
        }, _toDisplayString(_ctx.$t("status.unregistered")), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_input, {
                modelValue: searchKeyword.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchKeyword).value = $event)),
                placeholder: _ctx.$t('tip.searchDomainOrUsername'),
                clearable: "",
                style: {"width":"280px"},
                disabled: isLoading.value
              }, null, 8, ["modelValue", "placeholder", "disabled"]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("title.sortBy")), 1),
              _createVNode(_component_el_select, {
                modelValue: sortBy.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((sortBy).value = $event)),
                style: {"width":"260px"},
                disabled: isLoading.value,
                onChange: onSortChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _ctx.$t('fields.id'),
                    value: "id_asc"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: getSortLabel('created_at', 'earliest'),
                    value: "created_at_asc"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: getSortLabel('created_at', 'latest'),
                    value: "created_at_desc"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: getSortLabel('updated_at', 'latest'),
                    value: "updated_at_desc"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: getSortLabel('expires', 'earliest'),
                    value: "expires_asc"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: getSortLabel('expires', 'latest'),
                    value: "expires_desc"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_button, {
                plain: "",
                loading: isLoading.value,
                onClick: fetchData
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
                ]),
                _: 1
              }, 8, ["loading"]),
              (isSuperAdmin.value)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    disabled: isLoading.value,
                    onClick: openCreate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("action.addDomain")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_16, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.domain")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.expires")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.userName")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.registrar")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updated_at")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && filteredAndSortedItems.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAndSortedItems.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(formatCell(item.domain)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(expiresTextClass(item.expires))
                        }, _toDisplayString(formatCell(item.expires)), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(formatCell(item.username)), 1),
                      _createElementVNode("td", null, _toDisplayString(formatCell(item.registrar)), 1),
                      _createElementVNode("td", null, [
                        (item.updated_at)
                          ? (_openBlock(), _createBlock(_component_TimeShow, {
                              key: 0,
                              type: "GMToneLiner",
                              "date-iso-string": item.updated_at
                            }, null, 8, ["date-iso-string"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "medium",
                          onClick: ($event: any) => (openDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.viewDetails")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "warning",
                          plain: "",
                          size: "medium",
                          class: "ms-2",
                          loading: 
                    isDnsChecking.value && dnsCheckingDomainId.value === Number(item.id)
                  ,
                          onClick: ($event: any) => (handleDnsCheck(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.check")), 1)
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]),
                        (isSuperAdmin.value)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "danger",
                              size: "medium",
                              class: "ms-2",
                              loading: isDeleting(item.id),
                              onClick: ($event: any) => (handleDelete(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.delete")), 1)
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: detailVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((detailVisible).value = $event)),
        title: dialogTitle.value,
        width: "760px",
        "close-on-click-modal": true
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_el_button, {
              disabled: isSubmitting.value || isCheckLoading.value,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (detailVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            (isCreateMode.value && isSuperAdmin.value)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  loading: isSubmitting.value,
                  onClick: submitCreate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          (isCreateMode.value)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 0,
                ref_key: "createFormRef",
                ref: createFormRef,
                model: dialogForm.value,
                rules: createFormRules.value,
                "label-width": "160px",
                class: "pe-4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(createFields, (field) => {
                    return _createVNode(_component_el_form_item, {
                      key: field,
                      label: getFieldLabel(field),
                      prop: field
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: dialogForm.value[field],
                          "onUpdate:modelValue": ($event: any) => ((dialogForm.value[field]) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label", "prop"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["model", "rules"]))
            : (_openBlock(), _createBlock(_component_el_form, {
                key: 1,
                "label-width": "160px",
                class: "pe-4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailEditableFieldRows.value, (row, rowIndex) => {
                    return (_openBlock(), _createBlock(_component_el_row, {
                      key: `editable-${rowIndex}`,
                      gutter: 16
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (field) => {
                          return (_openBlock(), _createBlock(_component_el_col, {
                            key: field,
                            span: 12
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: getFieldLabel(field)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: dialogForm.value[field],
                                    "onUpdate:modelValue": ($event: any) => ((dialogForm.value[field]) = $event),
                                    disabled: !isSuperAdmin.value
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["label"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_el_form_item, {
                    label: getFieldLabel('check_country')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: dialogForm.value.check_country,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogForm.value.check_country) = $event)),
                        disabled: !isSuperAdmin.value
                      }, null, 8, ["modelValue", "disabled"]),
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (isSuperAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          loading: isSubmitting.value,
                          onClick: submitDetailUpdate
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: getFieldLabel('dns')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: dialogForm.value.dns,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogForm.value.dns) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: getFieldLabel('expires')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: dialogForm.value.expires,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogForm.value.expires) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: " ",
                    "label-width": "0",
                    class: "action-form-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_el_input_number, {
                          modelValue: refreshIntervalInput.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((refreshIntervalInput).value = $event)),
                          min: 1,
                          precision: 0,
                          step: 1,
                          controls: false,
                          style: {"width":"130px"}
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          onClick: handleSaveRefreshInterval
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_25, [
                          (isCheckIdEmpty.value)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                type: "primary",
                                plain: "",
                                loading: isCheckLoading.value,
                                onClick: handleCheck
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.check")), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"]))
                            : (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                type: "primary",
                                plain: "",
                                loading: isCheckLoading.value,
                                onClick: handleRefresh
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.refresh")), 1)
                                ]),
                                _: 1
                              }, 8, ["loading"])),
                          (!isCheckIdEmpty.value && isAutoRefreshing.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, " 自动刷新倒计时 " + _toDisplayString(refreshCountdownSec.value) + "s ", 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: getFieldLabel('check_result')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_27, [
                        (!checkResultEntries.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t("status.none")), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkResultEntries.value, (entry, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${entry.city}-${entry.network}-${index}`,
                            class: _normalizeClass(["check-result-card", 
                    entry.status === 'finished'
                      ? 'check-result-finished'
                      : 'check-result-updating'
                  ])
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              (entry.status !== 'finished')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(entry.city), 1),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(entry.network), 1),
                              _hoisted_33,
                              _createElementVNode("span", _hoisted_34, _toDisplayString(entry.avgText), 1),
                              _hoisted_35,
                              _createElementVNode("span", _hoisted_36, _toDisplayString(entry.lossText), 1)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _hoisted_38,
                              _createElementVNode("span", _hoisted_39, _toDisplayString(entry.resolvedAddress), 1)
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})